import { createSelector } from '@ngrx/store';
import { selectAllManifestEntries } from './entity-store-selectors';
import { selectTripPassengersByTripId } from './trip-passenger-selectors';
import { selectNonCancelledTripLegsByTripId } from './tripleg-selectors';

export function selectManifestEntriesByTripId(tripId: string) {
  return createSelector(
    selectAllManifestEntries,
    selectNonCancelledTripLegsByTripId(tripId),
    (manifestEntries, tripLegs) => {
      return manifestEntries
        .valueSeq()
        .filter((m) => tripLegs.find((t) => t.id === m.tripLegId) != null && m.dateDeleted == null);
    },
  );
}

export function selectManifestEntriesByTripLegId(tripLegId: string, tripId: string) {
  return createSelector(
    selectAllManifestEntries,
    selectTripPassengersByTripId(tripId),
    (manifestEntries, passengers) => {
      const entries = manifestEntries.filter((e) => e.tripLegId === tripLegId);
      return (
        passengers
          .sortBy((p) => p.abbreviation)
          .map((p) => entries.find((e) => e.passengerId === p.id))
          .filter((e) => e != null)
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          .map((e) => e!)
      );
    },
  );
}

export function selectManifestEntryById(id: string) {
  return createSelector(selectAllManifestEntries, (manifestEntries) => manifestEntries.get(id));
}

export function selectManifestEntryByLegAndPassengerId(tripLegId: string, passengerId: string) {
  return createSelector(selectAllManifestEntries, (manifests) => {
    return manifests
      .filter((manifest) => manifest.tripLegId === tripLegId)
      .find((manifest) => manifest.passengerId === passengerId && manifest.dateDeleted == null);
  });
}
